import { chain, curry, map, prop, zipObj } from 'ramda'

//used to pause on a tick, cleaner then timeouts.
// const dude = async () => {
//await pause(200)
//doSomething()
//}
export const pause = async (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export const delay = async (fn, ms) => {
  await pause(ms)
  await fn()
}

export const isNumeric = (number) => {
  return !isNaN(parseFloat(number)) && isFinite(number)
}

export const uniqueID = () => `_${Math.random().toString(36).substr(2, 9)}`

// this is better debounce.
// This is basically lodash debounce with one core difference
// the initial invocation passed through debounce will execute immeadately
export const debounce = (func, wait, immediate) => {
  let timeout = null
  const minWait = 10 //minimum amount of time it takes for any given user interaction (mouse click, key stroke)

  return (...args) => {
    const callNow = immediate && !timeout

    const later = function () {
      timeout = null
      if (!immediate) func.apply(this, args)
    }

    if (!timeout) {
      func.apply(this, args)
      timeout = setTimeout(later, minWait)
    } else {
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
    }

    if (callNow) func.apply(this, args)
  }
}

// given a list of objects - and assuming each object has a key "id"
// this will provide an object keyed by those id's
export const byId = curry((list) => chain(zipObj, map(prop('id')))(list))

export const popUp = ({
  path,
  onClose,
  onMessage = null,
  windowName = null,
  windowOptions = null,
}) => {
  windowName = windowName || 'ConnectWithOAuth' // should not include space for IE
  windowOptions = windowOptions || 'location=0,status=0,width=800,height=650'
  onClose = onClose || function () {}
  const _oauthWindow = window.open(path, windowName, windowOptions)
  const _oauthInterval = window.setInterval(function () {
    if (_oauthWindow && _oauthWindow.closed) {
      window.clearInterval(_oauthInterval)
      onClose()
    }
  }, 500)

  const eventer = window.addEventListener

  eventer('message', function handler(e) {
    if (e.origin !== window.location.origin || e.source !== _oauthWindow) return
    window.removeEventListener('message', handler)
    !!onMessage && onMessage(e)
  })

  return _oauthWindow
}

export const GoogleScopes = Object.freeze({
  CALENDAR: 'https://www.googleapis.com/auth/calendar',
  READ: 'https://www.googleapis.com/auth/gmail.readonly',
  SEND: 'https://www.googleapis.com/auth/gmail.send',
})

export const encodeQueryData = function (data) {
  const ret = []
  for (const key in data) {
    const value = data[key]
    if (Array.isArray(value)) {
      value.forEach((element) =>
        ret.push(`${encodeURIComponent(key)}=${encodeURIComponent(element)}`)
      )
    } else if (value !== null) {
      ret.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    }
  }
  return ret.join('&')
}

export const slugify = (text) => {
  return text
    .toString()
    .toLowerCase()
    .replace(/[^\w]+$/g, '') // remove trailing whitespace before slugifying
    .replace(/[^\w\-]+/g, '') // eslint-disable-line
    .replace(/\s+/g, '-') // eslint-disable-line
}
